import { CloudTowerGame } from './games';

export type GameType = 'cloud-tower';

export interface GameConfig {
  type: GameType;
  name: string;
  description: string;
}

export class GameManager {
  private container: HTMLElement;
  private currentGame?: CloudTowerGame;

  constructor(container: HTMLElement) {
    this.container = container;
  }

  static getAvailableGames(): GameConfig[] {
    return [
      {
        type: 'cloud-tower',
        name: 'Kiloba 9 Tầng Mây',
        description: 'Nhảy lên các đám mây di chuyển để chinh phục 9 tầng mây'
      }
      // Thêm games khác ở đây trong tương lai
    ];
  }

  startGame(gameType: GameType): void {
    // Destroy current game if exists
    this.destroyCurrentGame();

    // Start new game based on type
    switch (gameType) {
      case 'cloud-tower':
        this.currentGame = new CloudTowerGame(this.container);
        break;
      default:
        throw new Error(`Unknown game type: ${gameType}`);
    }
  }

  destroyCurrentGame(): void {
    if (this.currentGame) {
      this.currentGame.destroy();
      this.currentGame = undefined;
    }
  }

  getCurrentGame(): CloudTowerGame | undefined {
    return this.currentGame;
  }
}
